module.exports = __webpack_public_path__ + "img/Finishing_1200x800.ae93ac96.png";